$ = require 'jquery'
Browser = require '@trello/browser'

DragSort = require 'app/scripts/views/lib/drag-sort'
Controller = require 'app/scripts/controller'
Auth = require 'app/scripts/db/auth'
templates = require 'app/scripts/views/internal/templates'
Util = require 'app/scripts/lib/util'
{ isInspirationBoard } = require 'app/scripts/views/onboarding/helpers'

module.exports._applySettings = ->
  if !@options.settings?
    return

  { menu, filter } = @options.settings

  switch menu
    when 'closed'
      @model.viewState.setShowSidebar(false)
    when 'filter', 'activity'
      @setSidebarShow()
      @sidebarView.pushView(menu)

  if filter
    @model.filter.fromQueryString(filter)

module.exports.renderOpen = ->
  @showSidebarOnOpen()

  data = {}
  data.url = Controller.getBoardUrl(@model)
  for preference in @model.prefNames.concat(@model.myPrefNames)
    data["#{preference}_#{@model.getPref(preference)}"] = true
  data.canJoin = @model.canJoin()
  data.canInviteMembers = @model.canInviteMembers()
  data.confirmed = Auth.me().get('confirmed')

  @listListView.$el.detach()
  @$el.html templates.fillFromModel(require('app/scripts/views/templates/board'), @model)

  @renderBoardHeader()
  @renderBoardWarnings()
  @renderBoardBackground()

  # this prevents the sidebar from animating in when first rendering.
  if @model.viewState.get('showSidebar')
    @$el.addClass('is-show-menu')

  @appendSubview @sidebarView, @$('.js-fill-board-menu')

  @renderSidebarState()
  @renderLists()
  @renderInspirationPopover()
  @renderInviteeOrientation()
  @renderBoardBackgroundPrompt()
  @renderJswCrossflowPopover()

  Controller.setLocation(title: data.name)

  @defer =>
    @$('#board').unbind('mousedown.dragscrollable').dragscrollable
      fxIgnore: (event) ->
        boardEl = $(event.target).closest('#board')
        isScrollbar = event.offsetY > (boardEl.height() - 11)
        isList = $(event.target).closest('.js-list-content').length > 0
        isListComposer = $(event.target).closest('.js-add-list').length > 0
        isScrollbar || isList || isListComposer

    DragSort.refreshListSortable()
  return

module.exports._shouldCloseBoardMenu = ->
  isNewBoard = (new Date() - Util.idToDate(@model.id)) < 180000

  # if a previous render of this board marked it as needing its menu closed,
  # keep it closed until the user opens it themselves
  @shouldCloseBoardMenu ||
  # close the menu of the first board they ever load
  !Auth.me().isDismissed('close-menu-of-first-board') ||
  # close menu of first board ever created, which may not be the same as the
  # first board they ever load, because of invitations
  (isNewBoard && @model.isFirstOwnedBoard()) ||
  # Its an inspiration board made from onboarding
  isInspirationBoard(@model.get('id'))

module.exports._isFirstBoardEverLoaded = ->
  !Auth.me().isDismissed('close-menu-of-first-board') && !@model.isWelcomeBoard()

module.exports._isGhostUsingInviteLink = ->
  Util.hasValidInviteTokenFor(@model)

module.exports.removeSidebarDisplayTypes = ->
  @$el.removeClass('sidebar-display-wide')
  return

module.exports.renderSidebarDisplayType = ->
  displayClass = @model.viewState.getSidebarDisplayType()
  @$el.addClass(displayClass)
  return

module.exports.showSidebarOnOpen = ->
  # Orient visitors to public boards if About This Board is enabled
  fromPrefOrNotLoggedIn = @model.viewState.getShowSidebarFromPref() || Auth.me().get('notLoggedIn')
  hasDesc = !!@model.get('desc')
  isMember = @model.isMember(Auth.me())
  if @model.isPublic() && !isMember && hasDesc && fromPrefOrNotLoggedIn && !Browser.isTouch()
    @model.viewState.set("showSidebar", true)
  else if @_shouldCloseBoardMenu() || Browser.isTouch()
    @model.viewState.set("showSidebar", false)
    if @_isFirstBoardEverLoaded() && !@_isGhostUsingInviteLink()
      @shouldCloseBoardMenu = true
      if (Auth.isLoggedIn())
        Auth.me().dismiss('close-menu-of-first-board')
  else
    @model.viewState.setShowSidebarFromPref()

module.exports.renderSidebarState = ->
  @renderSidebarDisplayType()

  if @model.viewState.get('showSidebar')
    @showSidebar()
    @model.viewState.set('showBoardBackgroundPromptPopover', false)
  else
    @hideSidebar()
    if @model.viewState.get('boardBackgroundPromptOpenedSidebar')
      @model.viewState.set('boardBackgroundPromptOpenedSidebar', false)
      @model.viewState.set('showBoardBackgroundPromptPopover', true)

  return

module.exports.toggleSidebar = ->
  @model.viewState.setShowSidebar(!@model.viewState.get('showSidebar'))

module.exports.setSidebarShow = ->
  @model.viewState.setShowSidebar(true)
  @shouldCloseboardMenu = false
  return

module.exports.showSidebar = ->
  @renderSidebarDisplayType()
  # this hides team onboarding tooltip that shows after you dismiss
  # the popover, which we should just close when the sidebar opens
  @unmountTeamOnboardingPupTooltip()

  # Hacky... the entire transition will be hidden if
  # there isn't a slight delay between unhiding and
  # enabling the transition class.
  clearTimeout @_sidebarHideTimeout
  @$('.js-fill-board-menu').removeClass('hide')
  @defer =>
    @$el.addClass('is-show-menu')

  @sidebarView.sendDrawerScreenEvent(@sidebarView.topSidebarViewName(), 'showSidebar')

  return

module.exports.hideSidebar = ->
  @$el.removeClass('is-show-menu')
  clearTimeout @_sidebarHideTimeout
  # Even though the is-show-menu class moves the menu out of view, we want
  # to also *actually* hide it, so the browser doesn't does something weird
  # when the user does something like Ctrl+F for text that appears in the
  # sidebar.
  #
  # We're delaying the hide because we're giving the CSS transition time to
  # complete.  We could try to trigger off of the transitionEnd event but
  # that can be problematic (if another transition starts before the first
  # one finishes or doesn't happen at all because there isn't actually a
  # change in the property being transitioned)
  #
  # The timeout value we're using here isn't meant to match the length of the
  # transition, but hopefully it's longer than whatever the transition is,
  # but not so short that someone could reasonably hide the menu and then
  # Ctrl+F for something that was on it
  @_sidebarHideTimeout = @setTimeout =>
    @$('.js-fill-board-menu').addClass('hide')
    if @model.viewState.get('boardBackgroundPromptOpenedSidebar')
      @renderBoardBackgroundPromptPopover()
  , 250

  return
